export enum AccountDetailsCardType {
    Search = 'search',
    Button = 'button',
  }
